import AxiosCustom from '../../../common/components/apiConfig';

export function clubmember_insert_pictuer(payload) {
    let config = {
        url: "update_request"
    }

    let data = {
        table: "clubmember",
        method_type:"update_profile_picture",
        data: payload.data ?payload.data :{}
    }


    return AxiosCustom(config, data)
}